import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailCampaignComponent } from './email-campaign.component';
import { EmailCampaignRoutingModule } from "./email-campaign-routing.module";
import { SideNavbarModule } from "../sidenavbar.module";
import { DataService } from "../data.service";
import { EmailCampaignConnectComponent } from './email-campaign-connect/email-campaign-connect.component';
import { EmailCampaignOutlookButtonComponent } from './email-campaign-outlook-button/email-campaign-outlook-button.component';
import { EmailCampaignGoogleButtonComponent } from './email-campaign-google-button/email-campaign-google-button.component';
import { EmailCampaignDashboardComponent } from './email-campaign-dashboard/email-campaign-dashboard.component';
import { EmailCampaignCreateCampaignComponent } from './email-campaign-create-campaign/email-campaign-create-campaign.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { CreateCampaignModalComponent } from './create-campaign-modal/create-campaign-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';

import { CreateCampaignZeroComponent } from './create-campaign-zero/create-campaign-zero.component';
import { ProgressPanelComponent } from './progress-panel/progress-panel.component';
import { EditPanelComponent } from './edit-panel/edit-panel.component';
import { EditorModule } from 'primeng/editor';
import { SelectModule } from 'primeng/select';
import { CampaignHeaderComponent } from './campaign-header/campaign-header.component';
import { CampaignListingComponent } from './campaign-listing/campaign-listing.component';
import { EmailCampaignFilterComponent } from './email-campaign-filter/email-campaign-filter.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { EmailCampaignCandidateSliderComponent } from './email-campaign-candidate-slider/email-campaign-candidate-slider.component';
import { PersonSearchModule } from '../person-search/person-search.module';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from "@angular/material/chips";
import { EmailCampaignService } from "./email-campaign.service";
import { EmailCampaignLimitsComponent } from './email-campaign-limits/email-campaign-limits.component';
import { SharedModule } from '../shared/shared.module';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AttachmentListComponent } from '../attachment-list/attachment-list.component';
import { HireSidebarComponent } from '../hire-sidebar/hire-sidebar.component';
import { DropdownToggleDirective } from '../directives/dropdown-toggle.directive';

@NgModule({
  declarations: [
    EmailCampaignComponent,
    EmailCampaignConnectComponent,
    EmailCampaignOutlookButtonComponent,
    EmailCampaignGoogleButtonComponent,
    EmailCampaignDashboardComponent,
    EmailCampaignCreateCampaignComponent,
    CreateCampaignModalComponent,
    CreateCampaignZeroComponent,
    ProgressPanelComponent,
    EditPanelComponent,
    CampaignHeaderComponent,
    CampaignListingComponent,
    EmailCampaignFilterComponent,
    EmailCampaignCandidateSliderComponent,
    EmailCampaignLimitsComponent,
    AttachmentListComponent

  ],

  imports: [
    SharedModule,
    CommonModule,
    EmailCampaignRoutingModule,
    SideNavbarModule,
    MatPaginatorModule,
    MatTableModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    SelectModule,
    MatRadioModule,
    MatCheckboxModule,
    MatTooltipModule,
    PersonSearchModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatChipsModule,
    NgbDropdownModule,
    HireSidebarComponent,
    DropdownToggleDirective
  ],

  providers: [
    DataService,
    EmailCampaignService
  ],

  exports: [
    EmailCampaignCreateCampaignComponent,
    CampaignListingComponent,
    CreateCampaignZeroComponent
  ]
})
export class EmailCampaignModule {

  constructor (private navService: DataService) {
    if (this.navService) {
      this.navService.addNavModule({
        name: 'Email Campaign',
        route: '/email-campaign',
        icon: 'fa-solid fa-envelopes-bulk',
        activeClass: 'active'
      });
    }
  }
}
